import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Grid, Button, DataTable, DialogContact, DialogImport } from "../../../../";
import { makeStyles } from "@material-ui/core/styles"; // import { Link } from 'react-router-dom';

var useStyles = makeStyles(function (theme) {
  return {
    root: {
      padding: "4px 25px"
    },
    divider: {
      height: "4px"
    },
    mr30: {
      margin: "30px"
    },
    header: {
      display: "flex",
      "align-items": "center",
      "justify-content": "flex-end"
    },
    tabContainer: {
      display: "flex"
    },
    skeleton: {
      padding: "30px",
      width: "60%"
    }
  };
});

var Contacts = function Contacts(props) {
  var data = props.data,
      options = props.options,
      language = props.language,
      clientTypes = props.clientTypes,
      translation = props.translation,
      columns = props.columns,
      columnsImport = props.columnsImport; // console.log("props", props);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openContact = _useState2[0],
      setOpenContact = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openImport = _useState4[0],
      setOpenImport = _useState4[1];

  var classes = useStyles();

  var handleCreateContact = function handleCreateContact(values) {
    // console.log("Contact data subido al padre");
    props.createContact(values); // console.log(values);
  };

  var handleImportContacts = function handleImportContacts(data) {
    handleDialogImport();
    props.importContacts(data); // console.log('data importada', data);
  };

  var handleDialogContact = function handleDialogContact() {
    setOpenContact(!openContact);
  };

  var handleDialogImport = function handleDialogImport() {
    // console.log("handledialog");
    setOpenImport(!openImport);
  };

  return [/*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.header
  }, /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    className: classes.mr30,
    color: "primary",
    variant: "contained" // component={Link}
    // to="/franchises"
    ,
    onClick: handleDialogContact
  }, translation ? translation.buttons.add_contact : "+ CONTACT"), /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    className: classes.mr30,
    color: "primary",
    variant: "outlined" // component={Link}
    // to="/franchises"
    ,
    onClick: handleDialogImport
  }, translation ? translation.buttons["import"] : "IMPORT")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.editor
  }, /*#__PURE__*/React.createElement(DataTable, {
    key: language + "_contacts",
    type: "contacts",
    options: options,
    data: data,
    translation: translation ? translation.datatables.contact_list : columns ? columns : null
  })), /*#__PURE__*/React.createElement(DialogContact, {
    open: openContact,
    onClose: handleDialogContact,
    variant: "add",
    createContact: handleCreateContact,
    translation: translation ? translation.dialogs.add_contact : null //checked

  }), /*#__PURE__*/React.createElement(DialogImport, {
    open: openImport,
    onClose: handleDialogImport,
    titleSheet: "Contactos",
    options: options,
    importData: handleImportContacts,
    translation: translation ? translation.dialogs.import_contacts : null //checked
    ,
    columnsImport: columnsImport,
    language: language,
    link: "https://plantillas-excell.s3-eu-west-1.amazonaws.com/Manager/201909+Plantilla+contactos.xlsx"
  })];
};

export default Contacts;